<script lang="ts">
	import { allergensDataMap } from "../../../../core/schema/allergensDataMap.js";
	import type { Allergen } from "../../../../core/schema/Allergen.js";

	export let allergens: Allergen[];
</script>

<div class="mt-3 flex flex-col gap-3 lg:mt-2">
	{#if allergens.length > 0}
		<p class="font-semibold leading-6">Alergeny</p>
		<div class="flex flex-wrap gap-2">
			{#each allergens as allergen}
				{@const allergenData = allergensDataMap[allergen]}
				<span
					class="flex h-[1.3125rem] w-[1.3125rem] items-center justify-center rounded-full border border-secondary text-2xs font-semibold leading-3"
				>
					{allergenData.orderLabel}
				</span>
			{/each}
		</div>
	{/if}
</div>
